import axios from 'axios'

const url = 'https://fiemsapi.elkanisgroup.com/api/v1/farmers/'

// const baseurl = `${process.env.VUE_APP_API_URL}`
// const url = `${baseurl}/api/v1/farmers/`

class FarmerService {
  static getFarmers (options, filters) {
    return new Promise((resolve, reject) => {
      /* console.log(options, filters)
      const { page, itemsPerPage, sortBy, sortDesc } = options
      let sorting = sortBy
      if (sorting.length === 0) {
        sorting = ['_id']
      } else sorting = sortBy
      const sort = sorting.concat(JSON.parse(sortDesc))
      console.log(sort)
      const query = {
        filter: JSON.stringify(filters),
        range: JSON.stringify([(page - 1) * itemsPerPage, page * itemsPerPage - 1]),
        sort: JSON.stringify(sort)
      } */
      console.log(options, filters)
      const { page, itemsPerPage, sortBy, sortDesc } = options
      let sorting = sortBy
      if (sorting.length === 0) {
        sorting = ['_id']
      } else sorting = sortBy
      function getSort (sortvalue) {
        if (sortvalue) {
          return -1
        }
        return 1
      }
      function arraytoObject (array) {
        return array.reduce(function (result, currentArray) {
          result[currentArray[0]] = currentArray[1]
          return result
        }, {})
      }
      const sortOrder = getSort(sortDesc[0])
      const sort = sorting.concat(sortOrder)
      console.log(sort)
      console.log(arraytoObject([sort]))
      const query = {
        filter: JSON.stringify(filters),
        skip: JSON.stringify((page - 1) * itemsPerPage),
        limit: JSON.stringify(itemsPerPage),
        sort: JSON.stringify(arraytoObject([sort]))
      }
      axios.get(url, {
        params: query
      }).then((res) => {
        const data = res.data
        resolve(
          data
        )
      })
        .catch((err) => {
          reject(err)
        })
    })
  }

  static getFarmer (id) {
    return new Promise((resolve, reject) => {
      axios.get(`${url}${id}`).then((res) => {
        const data = res.data
        resolve(
          data
        )
      })
        .catch((err) => {
          reject(err)
        })
    })
  }

  static createFarmers (formData) {
    return axios.post(url, formData)
  }

  static deleteFarmer (id) {
    return axios.delete(`${url}${id}`)
  }
}

export default FarmerService
